import { ChevronDownIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr
} from "@chakra-ui/react";
import { ChangeEvent, useEffect, useState } from "react";
import { RiSearch2Line } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import AdminDashboardHeader from "../../components/admin/AdminHeader";
import AdminSidebar from "../../components/admin/AdminSidebar";
import Loading from "../../components/common/Loading";
import adminHelpers from "../../services/admin/admin.service";
import userService from "../../services/user.service";

const AuditTrail = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [auditTrailArr, setAuditTrailArr] = useState([]);
  const [filteredAuditTrail, setFilteredAuditTrail] = useState([]);
  const [isSearchEmpty, setIsSearchEmpty] = useState(false);

  useEffect(() => {
    try{
      adminHelpers.getActivitylogs().then((res) => {
        
        setAuditTrailArr(res.data.data);
        setFilteredAuditTrail(res.data.data);
      });
    }catch(err) {
      
    }finally{
      setLoading(false);
    }
  }, []);

  const sortRecentFirst = () => {
    setFilteredAuditTrail([...filteredAuditTrail].sort((a:any,b:any)=> {
        return ((b.created_at > a.created_at) ? 1 : (b.created_at === a.created_at) ? 0 : -1)
    }))
    return filteredAuditTrail;
};

const sortOldestFirst = () => {
  setFilteredAuditTrail([...filteredAuditTrail].sort((a:any,b:any)=> {
        return ((a.created_at > b.created_at) ? 1 : (a.created_at === b.created_at) ? 0 : -1)
    }))
    return filteredAuditTrail;
};

  const getUser = async (id: string): Promise<string> => {
    try {
      const user = await userService.getUserProfile(id);
      
      return user.data.name;
    } catch (err) {
      
      throw err; 
    }
  };
  

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();
    
    if (!searchTerm) {
      setFilteredAuditTrail(auditTrailArr);
    } else {
      if (auditTrailArr) {
        const filtered = auditTrailArr.filter((each: any) =>
          each.auditable_type.toLowerCase().includes(searchTerm)
        );
        setFilteredAuditTrail(filtered);
        
        if (filtered && filtered.length > 0) setIsSearchEmpty(false);
        else setIsSearchEmpty(true);
      }
    }
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Flex>
          <Box width="18%" position="fixed" top="0" left="0" zIndex="1">
            <AdminSidebar />
          </Box>

          <Box width="82%" ml="18%">
            <AdminDashboardHeader />
            <Box
              bg="#F9F8F8"
              minHeight="90vh"
              height="auto"
              pb="1rem"
              pt="30px"
              pl="20px"
              pr="40px"
            >
              <Flex
                justifyContent="space-between"
                alignItems="center"
                py="26px"
              >
                <Box color="#2B2B2B" fontWeight="800" fontSize="27px">
                  Audit Trail
                </Box>
              </Flex>
              <Flex py="15px" flexDirection={'row'} justifyContent={'flex-start'} alignItems={'center'} gap={'0.3rem'}>
                <InputGroup
                  color="brand.subtitle"
                  bg="white"
                  width="30%"
                  mr="20px"
                >
                  <Input
                    height="40px"
                    onChange={(e) => handleSearchChange(e)}
                    placeholder="Search audit by auditable type..."
                    fontSize={12}
                    size="sm"
                  />

                  <InputRightElement
                    pointerEvents="none"
                    children={<RiSearch2Line color="red" size="0.9rem" />}
                  />
                </InputGroup>
                <Menu >
                <MenuButton fontSize="14px" as={Button} rightIcon={<ChevronDownIcon />}>
                    Sort By
                </MenuButton>
                <MenuList width='7rem'>
                    <MenuItem
                        fontSize="14px"
                        as={Button}
                        onClick={sortRecentFirst}
                    >Recent First</MenuItem>
                    <MenuItem
                        fontSize="14px"
                        as={Button}
                        onClick={sortOldestFirst}
                    >Oldest First</MenuItem>
                </MenuList>
                </Menu>
              </Flex>
              <Box width="100%">
                <TableContainer>
                  <Table variant="simple">
                    <Thead mb="10px">
                      <Tr
                        pb="10px"
                        borderBottom="1px solid"
                        borderColor="#D5D5D5"
                      >
                        <Th textTransform="none">User ID</Th>
                        {/* <Th textTransform="none">User</Th> */}
                        <Th textTransform="none">Created at</Th>
                        <Th textTransform="none">Event</Th>
                        <Th textTransform="none">Auditable Type</Th>
                        <Th textTransform="none">Url</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {
                       filteredAuditTrail && filteredAuditTrail.map((audit: any, i: number) => {
                          return (
                            <Tr bg='white' key={i}>
                              <Td>{audit.user_id}</Td>
                              {/* <Td>{getUser(audit.user_id)}</Td> */}
                              <Td>{audit.created_at}</Td>
                              <Td>{audit.event}</Td>
                              <Td >{audit.auditable_type}</Td>
                              <Td>{audit.url}</Td>
                            </Tr>
                          )
                        })
                      }
                    </Tbody>
                  </Table>
                </TableContainer>
              </Box>
            </Box>
          </Box>
        </Flex>
      )}
    </>
  );
};

export default AuditTrail;